<template>
  <a-modal
    title='可视化图表'
    :visible='visible'
    :confirm-loading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
    width='1300'
  >
    <div class='repaymentReportForProductbox'>
      <div class='repaymentReportForProductContent'>
        <!--            <div v-if='dataarr.length>1' style='margin-left: 5px'><h2>-->
        <!--              日期：{{ dataarr[0] }}~{{ dataarr[dataarr.length - 1] }}</h2></div>-->
        <!--            <div v-else style='margin-left: 5px'><h2>日期：{{ dataarr[0] }}</h2></div>-->
        <h2 style='margin-bottom: 0px;font-weight: bold;margin-left: 8px;'>盘号：&nbsp;{{ panhaoName }}</h2>
        <div style='width:100% ;display: flex ;align-items: center;justify-content: center'><h3
          style='margin-bottom: 10px;font-weight: bold;margin-left: 10px'>
          {{ usertype === '老户' ? '逾期率' : '首次逾期率'
          }}</h3></div>
        <div class='repaymentReportForProductechrtsbox'
             style='display: flex;flex-direction: column;justify-content: space-around;'>
          <div class='repaymentReportchartsBoxContent' ref='chartUvBox'
               style='width:100%; height: 800px; margin-bottom: 30px;margin-bottom: 30px;'></div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { repaymentReportForProduct } from '@/webpublicapi/order'

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      productName: '产品名',
      startTime: '',
      endTime: '',
      myechartsOne: '', //存储echarts的dom
      echartsDataList: [],//echarts用到的数据
      dataarr: [],//横坐标 日期
      projectarr: [],//产品名称数组
      usertype: '',
      rchartsData: [],
      panhaoName: ''
    }
  },
  created() {
    console.log('created')
  },
  mounted() {
    // this.confirmLoading = true
  },
  methods: {
    clearEcharts() {
      // console.log('准备清空echarts')
      // console.log('页面上有echats了吗myechartsOne---》', this.myechartsOne)
      // if (this.myechartsOne != null && this.myechartsOne != '' && this.myechartsOne != undefined) {
      //   console.log('清空')
      //   this.myechartsOne.dispose()
      // } else {
      //   console.log('不清空')
      // }
      // console.log('准备可以拿到dommdocument.querySelector(\'.repaymentReportchartsBoxContent\')',document.querySelector('.repaymentReportchartsBoxContent'))
      // // this.$echarts.init(document.querySelector('.repaymentReportchartsBoxContent')).clear()
      // this.$echarts.init(document.querySelector('.repaymentReportchartsBoxContent')).clear()
      // console.log('清空echarts~方法结束')
    },
    openModal() {
      console.log('openModal')
      this.visible = true
    },
    handleOk() {
      this.confirmLoading = false
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    //请求图的数据
    sendRequest(query) {
      console.log('echarts弹窗准备发请求的参数', query)
      if (query.custType == '2') {
        this.usertype = '老户'
      } else if (query.custType == '1') {
        this.usertype = '新户'
      }
      // 发送请求的逻辑
      repaymentReportForProduct(query).then((res) => {
        if (res.code === 1000) {
          const datalistint = res.data.rows.list
          console.log('准备处理给echarts的数据----》', datalistint)
          // 使用 sort 方法对数组进行排序
          datalistint.sort((a, b) => {
            // 提取括号外的日期部分，并转换为 Date 对象
            const dateA = new Date(a.endDate.split('(')[0])
            const dateB = new Date(b.endDate.split('(')[0])

            // 比较两个日期
            return dateA - dateB
          })
          console.log(datalistint)
          const datalist = datalistint
          this.panhaoName = datalist[0].appSsid

          this.dataarr = [...new Set(datalist.map(item => item.endDate))]
          console.log('this.dataarr---拿到所有的日期', this.dataarr)

          // 1. 提取所有产品种类名称，处理未定义的情况
          this.projectarr = [...new Set(datalist.map(item => item.productRiskNo !== undefined ? item.productRiskNo : 'emptyProductName'))]
          console.log('this.projectarr---拿到所有的产品名字', this.projectarr)
          //  2. 创建一个包含所有日期的产品种类数据结构
          const productData = {}
          this.projectarr.forEach(name => {
            productData[name] = this.dataarr.map(date => ({ date, rate: null }))
          })
          console.log('走到这里了吗？？')

          if (query.custType == '2') {
            console.log('数据是老户的内容哦')
            // 选择老虎将 oldFirstOverdueRate 存入对应的数组中
            datalist.forEach(item => {
              const productName = item.productRiskNo !== undefined ? item.productRiskNo : 'emptyProductName'
              const overdueRate = parseFloat(item.oldFirstOverdueRate)
              const dateIndex = productData[productName].findIndex(d => d.date === item.endDate)
              if (dateIndex !== -1) {
                productData[productName][dateIndex].rate = overdueRate
              }
            })
          } else if (query.custType == '1') {
            console.log('数据是新户的内容哦')
            // 选择新户将 firstOverdueRate 存入对应的数组中
            datalist.forEach(item => {
              const productName = item.productRiskNo !== undefined ? item.productRiskNo : 'emptyProductName'
              const overdueRate = parseFloat(item.firstOverdueRate)
              const dateIndex = productData[productName].findIndex(d => d.date === item.endDate)
              if (dateIndex !== -1) {
                productData[productName][dateIndex].rate = overdueRate
              }
            })
          }
          // 将数据转换为 ECharts 所需的格式
          this.rchartsData = this.projectarr.map(name => ({
            name: name,
            type: 'line',
            data: productData[name].map(d => d.rate)
          }))
          console.log('productData-------->', productData)

          console.log('series:', this.rchartsData)
        }
      }).catch(e => {

      })
      setTimeout(() => {
        this.$echarts.init(document.querySelector('.repaymentReportchartsBoxContent')).clear()
        this.drawEcharts()
      }, 1000)

    },
    drawEcharts() {
      console.log('开始画图拉', this.$refs)
      let chartDom = document.querySelector('.repaymentReportchartsBoxContent')
      console.log('chartDom----------》', chartDom)
      this.$echarts.init(chartDom).clear()
      this.myechartsOne = this.$echarts.init(chartDom)

      const tooplipValue = this.usertype === '老户' ? '逾期率' : '首次逾期率'
      let option

      option = {
        title: {
          text: '用户类型: ' + this.usertype
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let content = `${params[0].axisValueLabel}<br/>` // Initialize content with axis label

            params.forEach(item => {
              if (item.value !== undefined && item.value !== '') {
                content += `${item.marker} ${item.seriesName} ${tooplipValue} ：${item.value}%<br/>`
              }
            })

            return content
          },
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderColor: '#ccc',
          borderWidth: 1,
          textStyle: {
            color: '#000'
          }
        },
        legend: {
          data: this.projectarr //存放所有产品名称数组
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dataarr // 存放所有日期的数组
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 在 y 轴标签中添加百分号
          }
        },
        series: this.rchartsData.map(series => ({
          ...series,
          markLine: {
            data: this.dataarr.map((_, index) => ({
              xAxis: this.dataarr[index]
            })),
            lineStyle: {
              type: 'dotted', // 可以设置为 'solid' 或其他类型
              color: '#aaa' // 竖线的颜色
            },
            label: {
              show: false // 不显示标线标签
            }
          }
        }))
      }
      option && this.myechartsOne.setOption(option)
    }
  }
}
</script>

<style>
</style>